import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  BarChart3, 
  Users, 
  Receipt, 
  ArrowLeftRight,
  Split,
  Home
} from 'lucide-react';

const MobileFooterNav = () => {
  const location = useLocation();
  
  // Core navigation items - Income, Investments, Budget moved to hamburger menu
  const navItems = [
    { name: 'Quick Links', href: '/quick-links', icon: Home },
    { name: 'Dashboard', href: '/stats', icon: BarChart3 },
    { name: 'Groups', href: '/groups', icon: Users },
    { name: 'Expenses', href: '/expense-list', icon: Receipt },
    { name: 'Split', href: '/split-expense', icon: Split },
    { name: 'Cash Flow', href: '/cashflow', icon: ArrowLeftRight },
  ];

  const isActive = (href) => {
    if (href === '/quick-links') {
      return location.pathname === '/quick-links' || location.pathname === '/';
    }
    if (href === '/stats') {
      return location.pathname === '/stats';
    }
    return location.pathname.startsWith(href);
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
      <div className="flex justify-around items-center h-16 px-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.href);
          
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex flex-col items-center justify-center flex-1 py-2 px-1 transition-colors ${
                active
                  ? 'text-emerald-600'
                  : 'text-gray-500 hover:text-emerald-500'
              }`}
            >
              <div className={`p-1.5 rounded-lg ${active ? 'bg-emerald-100' : ''}`}>
                <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : ''}`} />
              </div>
              <span className={`text-[10px] mt-0.5 ${active ? 'font-semibold' : 'font-medium'}`}>
                {item.name}
              </span>
            </Link>
          );
        })}
      </div>
      {/* Safe area padding for devices with home indicator */}
      <div className="h-safe-area-inset-bottom bg-white" />
    </nav>
  );
};

export default MobileFooterNav;
